import React from 'react';

export const MinorInfoCard = (props) => (
	<div className="minor-question-results">
		<p className="description">Your responses to the Minor Visitor Questionnaire are listed below.</p>
		<ul className="visitation-result-cards">
			<li className="result-data">
				{props.victimOfOffender.value.toLowerCase() == "no" ? (
					<p>The minor is not a victim of the crime of the inmate they wish to visit.</p>
				) : (
					<p>The minor is a victim of the crime of the inmate they wish to visit.</p>
				)}
			</li>
			<li className="result-data">
				{props.felonyConviction.value.toLowerCase() == "no" ? (
						<p>The minor has never been convicted of a felony.</p>
					) : (
						<p>The minor has been convicted of a felony.</p>
					)		
				}
			</li>
			<li className="result-data">
				{props.courtSupervision.value.toLowerCase() == "no" ? (
						<p>The minor is not currently under active court supervision.</p>
					) : (
						<p>The minor is currently under active court supervision.</p>
					)	
				}
			</li>
			<li className="result-data">
				{props.gangAssociation.value.toLowerCase() == "no" ? (
						<p>The minor has never been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1.</p>
					) : (
						<p>The minor has been a member of a gang, racial supremacy group, or another similar organization as defined in the Code of Virginia §18.2-46.1.</p>
					)				
				}
			</li>
		</ul>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/MinorInfoCard/MinorInfoCard.js